import React, { useState } from 'react';
import TopicManagement from './TopicManagement';
import HotTopicsManagement from './HotTopicsManagement';
import './TopicManagementPage.css';

type TopicTab = 'topics' | 'hot-topics';

const TopicManagementPage = () => {
  const [activeTab, setActiveTab] = useState<TopicTab>('hot-topics');

  return (
    <div className="topic-management-page">
      <div className="topic-management-tabs" role="tablist" aria-label="Topic management sections">
        <button
          type="button"
          role="tab"
          aria-selected={activeTab === 'hot-topics'}
          className={activeTab === 'hot-topics' ? 'active' : ''}
          onClick={() => setActiveTab('hot-topics')}
        >
          Hot Topics
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={activeTab === 'topics'}
          className={activeTab === 'topics' ? 'active' : ''}
          onClick={() => setActiveTab('topics')}
        >
          Topics
        </button>
      </div>

      <div role="tabpanel">
        {activeTab === 'topics' ? <TopicManagement /> : <HotTopicsManagement />}
      </div>
    </div>
  );
};

export default TopicManagementPage;
